var map = {
	"./region-1.png": "b08e",
	"./region-10.png": "7770",
	"./region-11.png": "03d3",
	"./region-12.png": "c12a",
	"./region-13.png": "563f",
	"./region-14.png": "36b2",
	"./region-15.png": "4aff",
	"./region-16.png": "eb1d",
	"./region-17.png": "739f",
	"./region-18.png": "df3f",
	"./region-19.png": "4a2a",
	"./region-2.png": "6968",
	"./region-20.png": "9501",
	"./region-21.png": "eaeb8",
	"./region-22.png": "e589",
	"./region-23.png": "24ca",
	"./region-24.png": "0159",
	"./region-25.png": "b6223",
	"./region-26.png": "5bfc",
	"./region-27.png": "2b11",
	"./region-28.png": "03d1",
	"./region-29.png": "a0de",
	"./region-3.png": "7aaf",
	"./region-30.png": "e389",
	"./region-31.png": "24ed",
	"./region-32.png": "9d50",
	"./region-33.png": "abaf",
	"./region-34.png": "bef7",
	"./region-4.png": "598c",
	"./region-5.png": "4783",
	"./region-6.png": "18e8",
	"./region-7.png": "186e",
	"./region-8.png": "78e9",
	"./region-9.png": "2ac8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "869b";